import { Label } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import * as React from 'react';

import * as styles from './Labels.css';
import { BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT } from '../../constants/experiments';
import { experimentToggle } from '../experimentToggle';

interface ILabelsProps {
  labels: ILabel[];

  isRedesignExperimentActive?: boolean;
}

interface ILabel {
  title: string;
  color: string;
}

type TColorMap = { [key in string]: TColors };

const LABEL_BACKGROUND_COLOR: TColorMap = {
  green: 'accent-positive-secondary',
  red: 'surface-negative-default',
  gray: 'overlay-control-default',
  blue: 'accent-main-secondary',
  purple: 'decorative-lavender-transparent',
  pink: 'brand-pink',
  orange: 'surface-warning-default',
  white: 'background-primary',
};

const LABEL_TEXT_COLOR: TColorMap = {
  green: 'accent-positive-primary',
  red: 'accent-negative-primary',
  gray: 'theme-dark',
  blue: 'accent-main-primary',
  purple: 'decorative-purple',
  pink: 'theme-dark',
  orange: 'accent-warning-primary',
  white: 'theme-dark',
};

export const Labels: React.FC<ILabelsProps> = ({ labels, isRedesignExperimentActive = false }) => {
  /**
   * Временное решение вынести в отдельную переменную, чтобы упростить код внутри experimentToggle
   */
  const content = (
    <>
      {labels.map(({ color, title }, index) => (
        <Label key={index} background={LABEL_BACKGROUND_COLOR[color]} color={LABEL_TEXT_COLOR[color]}>
          {title}
        </Label>
      ))}
    </>
  );

  /**
   * @todo experimentToggle - временное решение, удалить после завершения эксперимента aud_mobile_bx585_saved_search_favorites_merge
   */
  return experimentToggle(
    isRedesignExperimentActive,
    BX_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT,
    <div className={styles['container']}>{content}</div>,
    <div className={styles['container--redesign']}>{content}</div>,
  );
};
